import { BaseComponentFields } from '@/types';
import utils from '@/utils/index';
import { CSSProperties } from 'vue';
import { merge } from 'lodash-es';

export const baseComClass = (
  fields: BaseComponentFields | undefined | null,
  ...classes: Array<any>
) => {
  const result = ['gsc', ...classes];
  if (!fields) return result;
  const [mt, pt, pb] = utils.sp.getValByFields(fields, 'marginTop', 'paddingTop', 'paddingBottom');
  if (mt) result.push(`mt-${mt}`);
  if (pt) result.push(`pt-${pt}`);
  if (pb) result.push(`pb-${pb}`);
  return result;
};
export const baseComStyle = (fields: BaseComponentFields | undefined | null) => {
  const result: CSSProperties = {};
  if (!fields) return result;
  const [bcVal, fcVal] = utils.sp.getValByFields(fields, 'backColor', 'foreColor');
  if (bcVal) merge(result, { '--back-color': bcVal });
  if (fcVal) merge(result, { '--color': fcVal });
  if (fields.theme?.value) merge(result, { backgroundColor: fields.theme.value });
  return result;
};
